// v2 notification types with plain-language descriptions, grouped for the
// settings screen. Keys match NOTIFICATION_TYPES on the backend.

export const ARTIST_NOTIFICATION_TYPES = [
  { key: "playlist_adds_daily", title: "Playlist adds", description: "A daily count of how many playlists your songs were added to." },
  { key: "playlist_favorited_100", title: "Playlist hit 100 saves", description: "A playlist featuring you was saved by 100 people." },
  { key: "new_listeners_today", title: "New listeners", description: "How many people heard you for the first time today." },
  { key: "retention_up", title: "Retention up", description: "Viewers stayed longer in your latest stream than before." },
  { key: "most_watched_performance", title: "Most-watched performance", description: "A stream became your most-watched so far." },
  { key: "song_streams_milestone", title: "Song stream milestones", description: "A song crossed 1,000, 10,000 or 100,000 streams." },
  { key: "fans_returned", title: "Fans came back", description: "People who watched before returned to your next stream." },
  { key: "fan_attended_5", title: "Regulars", description: "A fan has attended five of your performances." },
  { key: "trending_in_city", title: "Trending in a city", description: "You entered a city leaderboard." },
  { key: "new_countries", title: "New countries", description: "Listeners from a country you had not reached before." },
  { key: "powerplay_listeners", title: "PowerPlay listeners", description: "How many people a PowerPlay brought in." },
  { key: "performance_shared", title: "Performance shared", description: "Someone shared one of your streams." },
  { key: "near_artist_level", title: "Close to the next level", description: "You are within reach of the next artist level." },
  { key: "royalties_offline", title: "Royalties offline", description: "Royalty settlement paused; nothing is lost, it will catch up." },
  { key: "artist_milestone", title: "Milestones", description: "Stream counts, fans, tips and listening-hour milestones." },
];

export const FAN_NOTIFICATION_TYPES = [
  { key: "supported_artist_live", title: "Supported artist is live", description: "An artist you support just went live." },
  { key: "favorite_artist_new_song", title: "New song from a favourite", description: "An artist you follow released a song." },
  { key: "playlist_reached_listeners", title: "Your playlist found listeners", description: "A playlist you made reached new people." },
  { key: "artist_noticed_you", title: "An artist thanked you", description: "An artist sent you a thank-you or a reward." },
  { key: "top10_fans", title: "Top 10 fan", description: "You entered an artist's top 10 supporters." },
  { key: "early_discovery_trending", title: "Early discovery paid off", description: "An artist you found early is now trending." },
  { key: "streak_expiring", title: "Streak about to end", description: "A reminder before a listening or live streak expires." },
  { key: "one_action_from_level", title: "One step from a level", description: "A single action would unlock your next fan level." },
  { key: "playlist_artists_live_week", title: "Playlist artists live this week", description: "Artists from your playlists have streams scheduled." },
  { key: "helped_discover_milestone", title: "You helped a milestone", description: "A song you completed or saved just hit a milestone." },
  { key: "mission_complete", title: "Mission complete", description: "You finished a mission and earned its points." },
  { key: "badge_earned", title: "Badge earned", description: "A new badge landed on your profile." },
  { key: "fan_level_up", title: "Level up", description: "You reached a new fan level." },
];

export const NOTIFICATION_GROUPS = [
  { key: "artist", title: "Artist", types: ARTIST_NOTIFICATION_TYPES },
  { key: "fan", title: "Fan", types: FAN_NOTIFICATION_TYPES },
];

// Preferences payload may be a flat map or wrapped in { preferences }.
// Every type is on by default, so a missing key reads as true.
export function normalizePreferences(result) {
  // Backend shape is { types: {<type>: bool}, digestHour }; older callers may
  // send a flat map or { preferences }.
  const map = result && typeof result === "object" && result.types && typeof result.types === "object"
    ? result.types
    : result && typeof result === "object" && result.preferences && typeof result.preferences === "object"
    ? result.preferences
    : result && typeof result === "object" ? result : {};
  const out = {};
  for (const group of NOTIFICATION_GROUPS) {
    for (const t of group.types) out[t.key] = map[t.key] === undefined || map[t.key] === null ? true : Boolean(map[t.key]);
  }
  return out;
}
